import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng/errorBoundary';
import {handleAd} from  '../../../../../../../utils/utils'
class TxtAd extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
        ad: PropTypes.object,
    };
    async componentDidMount() {
        // this.props.content.data.pos = 0
        const callbackFn = await handleAd(this.props.content);
        callbackFn(this.refs.txtData, this.props.content.data)
    }

    render() {
        return (
            <div className={styles.ad_wrap}>
                <div ref="txtData"></div>
                <div className={styles.space10} />
            </div>
        );
    }
}

export default errorBoundary(TxtAd);
